import React from "react";
import { Row , Col } from "react-bootstrap";
import Button from "react-bootstrap/Button";
import "./headbar.css"

export default function HeadBar({ headText , apiLink , apiImg }){

    return (
        <Row
            className = "headbar-row"
        >
            <Col
                className = "headbar-col"
            >
                <img 
                    className = "app-img"
                    alt = "api-img" 
                    src = { apiImg } 
                />
            </Col>
            <Col
                className = "headbar-col"
            >
                <p>
                    { headText }
                </p>
            </Col>
            <Col
                className = "headbar-col"
            >
                <a 
                    href = { apiLink }
                    className = "api-link"
                >
                    {"Go to the API >"}
                </a>
            </Col>

        </Row>
    )
}